var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #cf142b;\n      }\n\n      .cls-3 {\n        fill: #00247d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg3403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3408",
    className: "cls-3",
    d: "M0,0v600h1200V0H0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3410",
    className: "cls-1",
    d: "M.14.18L.04,68.03l465.63,232.65L.17,533.11l-.17,66.65,134.1.16,465.62-232.35,466.45,232.35,133.8.08v-66.26l-466.16-233.07,466.13-232.7.06-67.96h-133.33s-466.95,233.73-466.95,233.73L131.91.11.14.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3473",
    className: "cls-2",
    d: "M599.47,300.74l89.44-.32,511.09,256.14-.84,43.1-599.69-298.91h0ZM1109.41,0l86.67.12-596.66,300.76-.04-45.07L1109.42,0h-.01ZM254.71,171.45L0,43.72V0l599.55,300.64-88.36.12L254.71,171.45h0ZM599.44,300.64v43.72l-509.97,255.58-89.18.06,599.15-299.36h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3414",
    className: "cls-1",
    d: "M500,0v200H0v200h500v200h200v-200h500v-200h-500V0h-200Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3416",
    className: "cls-2",
    d: "M540,0v240H0v120h540v240h120v-240h540v-120h-540V0h-120Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUk);
export default __webpack_public_path__ + "static/media/Flag_UK.c099a60d1253bdcc6bf7425c9a3c7bb6.svg";
export { ForwardRef as ReactComponent };